import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const ReasonAbsence = ({
    registrationIdsSelected,
    isActiveFilter
}) => {
    const [idItem, setIdItem] = useState(null);
    const [dsReason, setDsReason] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingItemPanel, setLoadingItemPanel] = useState(null);
    const [recordsItemByUserId, setRecordsItemByUserId] = useState(null);
    const [attributesDetailItemPanel, setAttributesDetailItemPanel] = useState(null);
    const [reasonAbsenceIdSelected, setReasonAbsenceIdSelected] = useState([]);

    const readOnlyAttributes = !(inserting || updating);

    const attributeList = [
        { name: "id", value: idItem, setter: setIdItem },
        { name: "dsReason", value: dsReason, setter: setDsReason },
        {
            name: "isActive", value: isActive, setter: setIsActive, resetValue: 'S', readOnlyGrid: true,
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setReasonAbsenceIdSelected([])
    }, [isActiveFilter]);

    useEffect(() => {
        reloadListItem()
    }, [registrationIdsSelected, isActiveFilter])

    useEffect(() => {
        if (reasonAbsenceIdSelected && reasonAbsenceIdSelected.length === 1) {
            fetchDataDetail(reasonAbsenceIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [reasonAbsenceIdSelected]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '83%'
    };

    async function reloadListItem() {
        const parameters = { onlyActive: isActiveFilter }
        const items = await ExecuteAxios.api('get', `/absence-reason/get-absence-reason-grid/`, { params: parameters });
        setRecordsItemByUserId(items);
        RemoveIdsNotFound.remove(items, setReasonAbsenceIdSelected, reasonAbsenceIdSelected)
    }

    const fetchDataDetail = async (reasonAbsenceIdSelected) => {
        const parameters = { id: reasonAbsenceIdSelected ? reasonAbsenceIdSelected : 0 }
        const item = await ExecuteAxios.api('get', `/absence-reason/get-absence-reason-detail/`, { params: parameters })
        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }

        if (!reasonAbsenceIdSelected || reasonAbsenceIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getItemPanelListOrDetail = () => {
        if (!updating && !inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setReasonAbsenceIdSelected}
                    idsSelected={reasonAbsenceIdSelected}
                    data={recordsItemByUserId}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailItemPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('post', `/absence-reason/`, {
                dsReason: dsReason,
                isActive: isActive
            });

            if (response) {
                await reloadListItem()
            }
            return response;
        } finally {
            setLoadingItemPanel(false)
        }
    }

    async function putItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('put', `/absence-reason/`, {
                id: idItem,
                dsReason: dsReason,
                isActive: isActive
            });

            if (response) {
                await reloadListItem()
            }

            return response;
        } finally {
            setLoadingItemPanel(false)
        }
    }

    return (
        <LoadingIndicator loaded={!loadingItemPanel}>
            <Panel
                style={itemPanelStyle}
                titlePage={'Motivo Ausênsia'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={reasonAbsenceIdSelected && reasonAbsenceIdSelected.length === 1 && registrationIdsSelected && registrationIdsSelected.length === 1}
                putFunction={putItem}
                enableNewRecord={true}
                canNewRecord={registrationIdsSelected && registrationIdsSelected.length === 1}
                postFunction={postItem}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={reasonAbsenceIdSelected}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailItemPanel}
                attributeList={attributeList}
                onUpdateIdSelected={setReasonAbsenceIdSelected}
            >
                {getItemPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}
export default ReasonAbsence;